export default __webpack_public_path__ + "static/media/bad_weather.336f8fe5.svg";